module.exports = __webpack_public_path__ + "static/media/Orkos_Siopis_5.f6c66550.jpg";